import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0206 from "../lesson-06/lesson";
import lesson0207 from "../lesson-07/lesson";
import lesson0208 from "../lesson-08/lesson";
import lesson0209 from "../lesson-09/lesson";
import lesson0210 from "../lesson-10/lesson";
import lesson0211 from "../lesson-11/lesson";
const lessonLinks: LessonLink[] = [
  {
    id: "1ac4791a-9652-4204-bd74-9a47098f9c2a",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0206),
    lesson: lesson0206,
  },
  {
    id: "373d212f-9bbf-47a8-9da3-6303e1051607",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
  {
    id: "287fdc9c-096c-4aa3-ab88-c4ed54b0dd48",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0208),
    lesson: lesson0208,
  },
  {
    id: "6c5bb145-8243-42b2-9c4c-67575539f208",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0209),
    lesson: lesson0209,
  },
  {
    id: "0739d0e0-c1e9-40be-8236-18ffc235faed",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0210),
    lesson: lesson0210,
  },
  {
    id: "e3d4edae-47cb-4653-abc1-da9f2df2908b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0211),
    lesson: lesson0211,
  },
];

export default lessonLinks;
